import ajax, { init } from "@/lib/ajax";
// import { getBusinessId } from "./business";
import * as tokenStore from "./token";
import { getLoginUrl, useToken } from "./login";

let refreshTid;
export async function info() {
    refreshTid && clearTimeout(refreshTid);
    const token = tokenStore.get();
    if (useToken && token) {
        // 如果没 token 还去请求后台接口，会命中 10102
        // 因此这里没 token 照样放行无所谓
        init({ headers: { Authorization: token } });
    } else if (!useToken) {
        init({});
    }
    const result = await ajax.get("/xiaoyue-operation/member/info");
    if (!useToken) {
        return { ...result, token: "token" };
    }
    // 定时刷新 token
    refreshTid = setTimeout(refresh, 13 * 60 * 1000);
    return { ...result, token };
}

export async function refresh() {
    const { token } = await ajax.post("/xiaoyue-operation/login/refresh");
    tokenStore.set(token);
    await info();
}

export async function login(name, pw, ticket, randstr) {
    const result = await ajax.post("/xiaoyue-operation/login", { name, pw, ticket, randstr });
    const { token } = result;
    tokenStore.set(token);
    jump();
    return;
}

export async function logout() {
    tokenStore.clear();
    jump("login");
}

export async function jump(where = "home") {
    const prefix = window.BASE_URL || "/";
    const loginPage = getLoginUrl();
    location.href =
        {
            home: prefix,
            login: loginPage
        }[where] || loginPage;
}

export async function businessSetting() {
    const resp = await ajax.get("/xiaoyue-operation/business/getRobotsInfo");
    return {
        businessName: resp.business_name,
        languages: resp.langlist ? resp.langlist.split(",") : [],
        modules: resp.permit_code ? resp.permit_code.split(",") : [],
        robots: (resp.robot_info || []).map(rInfo => ({
            gameId: rInfo.game_id,
            robotName: rInfo.game_name,
            source: rInfo.answer_channel ? JSON.parse(rInfo.answer_channel) : [],
            defaultLang: rInfo.default_lang
        }))
    };
}
